(function () {
  'use strict';

  var modal = document.getElementById('LsEnquiryModal');
  if (!modal) return;

  function openEnquiry(trigger) {
    var product = trigger.getAttribute('data-product-title') || document.title;
    var productUrl = trigger.getAttribute('data-product-url') || window.location.href;
    if (productUrl.charAt(0) === '/') productUrl = window.location.origin + productUrl;

    var productInput = modal.querySelector('[data-enquiry-product-input]');
    var urlInput = modal.querySelector('[data-enquiry-url-input]');
    var bodyInput = modal.querySelector('[data-enquiry-body-input]');
    var productLabel = modal.querySelector('[data-enquiry-product-label]');

    if (productInput) productInput.value = product;
    if (urlInput) urlInput.value = productUrl;
    if (bodyInput) bodyInput.value = 'Product enquiry for: ' + product + '\nProduct URL: ' + productUrl;
    if (productLabel) productLabel.textContent = product;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ls-enquiry-open');

    window.setTimeout(function () {
      var firstInput = modal.querySelector('input:not([type="hidden"])');
      if (firstInput) firstInput.focus();
    }, 100);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-enquiry-open]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    openEnquiry(trigger);
  }, true);

  function isZeroPrice(priceElement) {
    var salePrice = priceElement.querySelector('ins');
    var source = salePrice || priceElement.cloneNode(true);
    if (!salePrice) {
      source.querySelectorAll('del, .t4s-badge-price').forEach(function (element) {
        element.remove();
      });
    }

    var value = source.textContent.match(/\d[\d,]*(?:\.\d+)?/);
    if (value) return Number(value[0].replace(/,/g, '')) === 0;

    var rawPrice = priceElement.getAttribute('data-ls-price-cents');
    return rawPrice !== null && rawPrice !== '' && Number(rawPrice) === 0;
  }

  function createButton(productCard) {
    var titleLink = productCard.querySelector('.t4s-product-title a, h3 a[data-pr-href]');
    if (!titleLink) return null;

    var button = document.createElement('button');
    var productTitle = titleLink.textContent.trim();
    button.type = 'button';
    button.className = 'ls-enquiry-card-trigger';
    button.setAttribute('data-enquiry-open', '');
    button.setAttribute('data-product-title', productTitle);
    button.setAttribute('data-product-url', titleLink.getAttribute('href') || window.location.href);
    button.setAttribute('aria-label', 'Enquire about ' + productTitle);
    button.setAttribute('title', 'Enquire Now');
    button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 3.75h14A1.25 1.25 0 0 1 20.25 5v14A1.25 1.25 0 0 1 19 20.25H5A1.25 1.25 0 0 1 3.75 19V5A1.25 1.25 0 0 1 5 3.75Z" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M7.5 8h9M7.5 12h9M7.5 16h5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
    return button;
  }

  function enhancePrice(priceElement) {
    if (!priceElement) return;

    var isZero = isZeroPrice(priceElement);
    priceElement.classList.toggle('ls-zero-price-hidden', isZero);

    var existingRow = priceElement.closest('.ls-card-price-row');
    var productCard = priceElement.closest('.t4s-pr-grid');
    if (!isZero) {
      if (productCard && existingRow && existingRow.parentNode) {
        existingRow.parentNode.insertBefore(priceElement, existingRow);
        existingRow.remove();
      }
      return;
    }
    if (!productCard || existingRow) return;

    var button = createButton(productCard);
    if (!button || !priceElement.parentNode) return;

    var row = document.createElement('div');
    row.className = 'ls-card-price-row';
    priceElement.parentNode.insertBefore(row, priceElement);
    row.appendChild(priceElement);
    row.appendChild(button);
  }

  function enhanceCards(root) {
    if (!root || root.nodeType !== 1) return;
    var selector = '.t4s-product-price, [data-pr-price], [data-product-price], [data-sticky-price]';
    if (root.matches && root.matches(selector)) enhancePrice(root);
    root.querySelectorAll(selector).forEach(enhancePrice);
  }

  enhanceCards(document.body);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(enhanceCards);
      enhanceCards(mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement);
    });
  }).observe(document.body, { childList: true, characterData: true, subtree: true });
})();
